var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3888 4.84628C17.3889 4.69658 17.3488 4.54955 17.2726 4.42019C17.1965 4.29084 17.087 4.1838 16.9554 4.10999C16.8238 4.03618 16.6748 3.99825 16.5235 4.00006C16.3723 4.00188 16.2242 4.04338 16.0945 4.12032L7.74858 9.0734H4.5648C3.14732 9.0734 2 10.2072 2 11.6117V18.3839C2 19.7867 3.14561 20.9222 4.5648 20.9222H7.74858L16.0927 25.8787C16.2225 25.956 16.3708 25.9979 16.5223 25.9999C16.6738 26.002 16.8231 25.9641 16.955 25.8902C17.0869 25.8164 17.1965 25.7092 17.2727 25.5796C17.349 25.45 17.389 25.3027 17.3888 25.1527V4.84628Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2631 19.8105C20.4462 19.9404 20.6978 20.0089 20.9553 19.9991C21.2129 19.9891 21.4526 19.9017 21.6153 19.7586C23.1569 18.4183 24 16.736 24 14.9999C24 13.2637 23.1569 11.5816 21.6153 10.2416C21.4526 10.0983 21.2129 10.0109 20.9553 10.0009C20.6978 9.99108 20.4462 10.0596 20.2631 10.1895C20.1026 10.3064 20.009 10.462 20.0006 10.6257C19.9924 10.7895 20.0699 10.9495 20.2181 11.0745C21.4878 12.1808 22.1817 13.5681 22.1817 15C22.1817 16.4317 21.4878 17.8192 20.2181 18.9256C20.0699 19.0504 19.9924 19.2106 20.0006 19.3743C20.009 19.5381 20.1026 19.6937 20.2631 19.8106V19.8105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMedium);
export default __webpack_public_path__ + "static/media/soundMedium.83c8bbb7d939395d35dc0cbd470e681b.svg";
export { ForwardRef as ReactComponent };